import { render } from "./ConfettiBurst.vue?vue&type=template&id=28899d23&scoped=true"
import script from "./ConfettiBurst.vue?vue&type=script&lang=js"
export * from "./ConfettiBurst.vue?vue&type=script&lang=js"

import "./ConfettiBurst.vue?vue&type=style&index=0&id=28899d23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28899d23"]])

export default __exports__